import { createRouter, createWebHistory } from 'vue-router'
import { isAuthenticated, runtimeConfig } from '@ck/auth'
import HomeView from './views/HomeView.vue'
import RelatorioView from './views/RelatorioView.vue'
import LoginView from './views/LoginView.vue'
import RegisterView from './views/RegisterView.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
    { path: '/criar-conta', name: 'register', component: RegisterView, meta: { public: true } },
    { path: '/auth/callback', redirect: '/' },
    { path: '/', name: 'home', component: HomeView },
    { path: '/relatorio', name: 'relatorio', component: RelatorioView },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ]
})

router.beforeEach((to) => {
  const authenticated = isAuthenticated()
  if (!to.meta.public && !authenticated) return { name: 'login' }
  if (to.name === 'login' && authenticated && runtimeConfig.authRequired) return { name: 'home' }
  return true
})

export default router
